.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
  width: 100%;
  padding-bottom: 1.6rem;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  padding: 1.6rem;
  height: 100%;
  background-color: var(--color-grayscale-eerie-black);
}

.page-header {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
}
